import { useAuth0 } from "./DevAuth0Provider";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useState } from "react";

const LoginButton = () => {
  const { loginWithRedirect, isLoading } = useAuth0();
  const [isClicked, setIsClicked] = useState(false);

  const handleLogin = async () => {
    setIsClicked(true);
    try {
      await loginWithRedirect({
        appState: { returnTo: "/app" }
      });
    } catch (error) {
      console.error('Login error:', error);
      setIsClicked(false);
    }
  };

  const isButtonLoading = isLoading || isClicked;

  return (
    <button
      onClick={handleLogin}
      disabled={isButtonLoading}
      className={`login-button tag-secondary transition-all duration-300 ease-out ${
        isButtonLoading
          ? 'opacity-75 scale-95 cursor-not-allowed'
          : 'opacity-100 scale-100 hover:scale-105 hover:bg-secondary-20'
      }`}
    >
      {isButtonLoading ? (
        <>
          <Icon
            icon="eos-icons:loading"
            className="text-4xl text-primary animate-spin"
          />
          <span>Redirecting...</span>
        </>
      ) : (
        <>
          <Icon icon="octicon:organization-16" className="text-4xl text-primary"></Icon>
          <span>Select Org</span>
        </>
      )}
    </button>
  );

};

export default LoginButton;
